<template>
  <div class="sign-claim-wrapper">
    <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
    <div class="sign-claim-container">
      <iframe
        v-if="documentViewerUrl"
        :src="documentViewerUrl"
        class="claim-document"
        title="claim-document"
      />
      <div class="sign-block">
        <div class="sign-title">Подпись:</div>
        <div class="sign-offer-item" @click.stop="checkboxHandler()">
          <div
            class="check-box-btn"
            :class="{ 'check-box-checked': isClaimAgreed }"
          >
            <img
              v-if="isClaimAgreed"
              class="check-box-image"
              src="../../../public/custom/images/check.svg"
              alt="Checked image"
            />
          </div>
          <div class="check-box-label">
            Текст Претензии прочитан мной полностью, с условиями ознакомлен(а) и согласен(а)
          </div>
        </div>
        <div class="otp-container">
          <div class="otp-block">
            <base-text-input
              :mask-pattern="'######'"
              :name="'claimOtp'"
              :validate-rules="'otp'"
              :placeholder="$t('message.contract.otp.placeholder')"
              v-model="otp"
              :disabled="!isClaimAgreed"
              :is-has-error-block="false"
            />
          </div>
          <div class="send-otp-btn">
            <base-button
              text="Получить код"
              :disabled="!isClaimAgreed"
              @click="getOtpCode()"
              min-height="40px"
            />
          </div>
        </div>
        <div class="lender-block">
          <div class="lender-title">Займодавец:</div>
          <div class="lender-full-name">{{ lenderFullName }}</div>
        </div>
        <div class="sign-claim-btn">
          <base-button
            text="Подписать претензию"
            :disabled="isSignClaimBtnDisabled"
            :is-loading="isSignClaimBtnLoading"
            @click="signClaim()"
            min-height="40px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTextInput from '../../components/base/BaseTextInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SignClaim',
  inject: ['$httpService'],
  components: {
    BaseTextInput,
    BaseButton
  },
  data() {
    return {
      blobUrl: '',
      isClaimAgreed: false,
      isOtpRequested: false,
      isSignClaimBtnLoading: false,
      otp: ''
    };
  },
  computed: {
    ...mapGetters(['profile']),
    documentViewerUrl() {
      if (!this.blobUrl) {
        return '';
      }

      return `${this.blobUrl}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&zoom=100`;
    },
    lenderFullName() {
      const lastName = this.profile?.name_ru?.family_name_ru || '';
      const firstName = this.profile?.name_ru?.given_name_ru || '';
      const middleName = this.profile?.name_ru?.middle_name_ru || '';

      return [lastName, firstName, middleName].filter(Boolean).join(' ');
    },
    isSignClaimBtnDisabled() {
      return !this.isOtpRequested || !this.otp || this.errors.has('claimOtp') || this.isSignClaimBtnLoading;
    }
  },
  async created() {
    const publicId = this.$route.params.id;

    this.$store.dispatch('loading', true);

    try {
      const response = await this.$httpService.claim.downloadClaim(publicId);
      this.showDocument(response);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.dispatch('loading', false);
    }
  },
  beforeDestroy() {
    this.revokeDocumentUrl();
  },
  methods: {
    checkboxHandler() {
      this.isClaimAgreed = !this.isClaimAgreed;

      if (!this.isClaimAgreed) {
        this.otp = '';
        this.isOtpRequested = false;
      }
    },
    async getOtpCode() {
      if (!this.isClaimAgreed) {
        return;
      }

      try {
        await this.$httpService.loan.getOtpCode();
        this.isOtpRequested = true;
        this.$toast.success(this.$t('message.signIn.otpToastMsg'));
      } catch (error) {
        console.log(error);
      }
    },
    async signClaim() {
      if (this.isSignClaimBtnDisabled) {
        return;
      }

      this.isSignClaimBtnLoading = true;

      try {
        const claim_public_id = this.$route.params.id;
        const otp = +this.otp;

        await this.$httpService.claim.signClaim(claim_public_id, otp);
        this.$toast.success('Претензия успешно подписана');
        this.$router.push({
          name: 'profile',
          params: this.$route.params.backRouteParams || {}
        });
      } catch (error) {
        this.$toast.error('Не удалось подписать претензию');
      } finally {
        this.isSignClaimBtnLoading = false;
      }
    },
    showDocument(response) {
      const contentType = response.headers['content-type'] || 'application/pdf';
      const blob = new Blob([response.data], { type: contentType });

      this.revokeDocumentUrl();
      this.blobUrl = window.URL.createObjectURL(blob);
    },
    revokeDocumentUrl() {
      if (this.blobUrl) {
        window.URL.revokeObjectURL(this.blobUrl);
        this.blobUrl = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .sign-claim-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 40px;
    box-sizing: border-box;
  }

  .sign-claim-container {
    @include base-page-container;

    flex-direction: column;
    min-height: calc(100vh - 434px);
  }

  .route-name {
    @include route-name;
    width: 95%;
    text-align: start;
    margin-bottom: 20px;
    margin-top: -20px;
  }

  .claim-document {
    width: 100%;
    flex: 1;
    min-height: 700px;
    border: none;
    border-radius: 10px;
    background-color: #ffffff;
  }

  .sign-block {
    width: 100%;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
  }

  .sign-title {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 16px;
    line-height: 135%;
    color: #121212;
  }

  .sign-offer-item {
    margin-bottom: 30px;
    display: flex;
    align-items: flex-start;
    cursor: pointer;
  }

  .check-box-btn {
    @include base-check-box;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }

  .check-box-image {
    width: 12px;
  }

  .check-box-label {
    @include base-check-box-label;

    font-size: 16px;
    line-height: 135%;
    font-weight: 500;
  }

  .otp-container {
    display: flex;
    user-select: none;
  }

  .otp-block {
    width: 280px;
    margin-right: 20px;
  }

  .send-otp-btn {
    width: 160px;
    height: 40px;
  }

  .lender-block {
    width: 100%;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
  }

  .lender-title {
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 16px;
    line-height: 135%;
    color: #121212;
  }

  .lender-full-name {
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #121212;
    text-transform: uppercase;
  }

  .sign-claim-btn {
    width: 220px;
    height: 40px;
    margin-top: 30px;
  }
</style>